import { useTranslation } from 'react-i18next';

export default function Safety() {
  const { t } = useTranslation();

  const tips = [
    t('safety.tip1'),
    t('safety.tip2'),
    t('safety.tip3'),
    t('safety.tip4'),
  ];

  const tableRows = [
    { el: t('safety.row1_col1'), practice: t('safety.row1_col2') },
    { el: t('safety.row2_col1'), practice: t('safety.row2_col2') },
    { el: t('safety.row3_col1'), practice: t('safety.row3_col2') },
    { el: t('safety.row4_col1'), practice: t('safety.row4_col2') },
  ];

  return (
    <section id="safety" className="w-full py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {t('safety.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t('safety.content')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
          {tips.map((tip, idx) => (
            <div key={idx} className="flex items-start gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-sm"></i>
              </div>
              <span className="text-sm text-foreground-700">{tip}</span>
            </div>
          ))}
        </div>

        <div className="rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="grid grid-cols-2 bg-background-100 border-b border-background-200/70">
            <div className="px-4 md:px-6 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
              {t('safety.table_header1')}
            </div>
            <div className="px-4 md:px-6 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
              {t('safety.table_header2')}
            </div>
          </div>
          {tableRows.map((row) => (
            <div key={row.el} className="grid grid-cols-2 border-b border-background-200/60 last:border-0 hover:bg-background-50 transition-colors">
              <div className="px-4 md:px-6 py-3.5 text-sm font-medium text-foreground-900">{row.el}</div>
              <div className="px-4 md:px-6 py-3.5 text-sm text-foreground-600">{row.practice}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}